<template>
    <span class="v3_style tooltip_wrap" v-show="isShow">
        <!-- 강상우 아래에 좌표 필요 -->
        <span class="tooltip" ref='tooltip' :style="styleObject">
            {{ content }}
        </span>
    </span>
</template>


<script>
export default {
    props: {
        mouseOverEvent: MouseEvent,
        content: String,
    },
    data() {
        return {
            resizeObserver: undefined,

            xPosition: 0,
            yPosition: 0,
            height: 0,
        }
    },
    watch: {
        mouseOverEvent: {
            immediate: true,
            handler: function(newValue) {
                if (newValue) {
                    this.xPosition = newValue.clientX
                    this.yPosition = newValue.clientY
                }
            }
        }
    },
    computed: {
        isShow: function() {
            return this.mouseOverEvent !== undefined
        },
        styleObject: function() {
            return {
                left: (this.xPosition + 5) + 'px',
                top: (this.yPosition - this.height + 5) + 'px'
            }
        },
    },
    methods: {},
}
</script>